import { createFileRoute, redirect } from '@tanstack/react-router'

// Federal Excise moved from the Materials data sources to the Pricing & Excise ones. Sends old links and
// bookmarks, with their search and hash, to the same page under the new path.
export const Route = createFileRoute('/_auth/_modules/crt/materials/data-sources/federal-excise/$')(
  {
    beforeLoad: ({ location }) => {
      throw redirect({
        href: location.href.replace(
          '/crt/materials/data-sources/federal-excise',
          '/crt/pricing-excise/data-sources/federal-excise',
        ),
        replace: true,
      })
    },
  },
)
